import React from 'react'

import { globalStatuses } from '../../../../../utilities/helpers'

import Form from 'react-bootstrap/Form'
import Badge from 'react-bootstrap/Badge'

import { Event } from '../../Event'

export default function CheckboxEvent({
  event,
  timezone,
  isChecked,
  handleCheck,
}) {
  const getBadgeType = (status) => {
    switch (status) {
      case 'on_sale':
        return 'onsale'

      case 'scheduled':
        return 'scheduled'

      case 'published':
        return 'published'

      case 'unpublished':
        return 'draft'

      default:
        return
    }
  }
  return (
    <li className="list-item list-item-lg list-item--light">
      <Form.Check
        type="checkbox"
        className={`form-check-display form-check-display--lg m-0 ${event.status === 'complete' ? 'pe-none opacity-50' : ''}`}
        id={`event-type-display-checkbox-${event.id}`}
      >
        <Form.Check.Input
          type="checkbox"
          name="display-event"
          disabled={event?.status === 'complete'}
          checked={isChecked(event.id)}
          onChange={(e) => handleCheck(event.id)}
          className="flex-shrink-0"
        />
        <div className="gap-3 flex-grow-1">
          <Form.Check.Label
            id={`event-type-display-checkbox-${event.id}`}
            className="m-0 d-flex gap-3 w-100 h-100 align-items-center"
          >
            <Event event={event} timezone={timezone}>
              <Badge
                bg="none"
                className={`badge--${getBadgeType(event?.status)}`}
              >
                {globalStatuses[event?.status]?.label}
              </Badge>
            </Event>
          </Form.Check.Label>
        </div>
      </Form.Check>
    </li>
  )
}
